import { render, staticRenderFns } from "./yunsischoolDetail.vue?vue&type=template&id=13ece416&scoped=true"
import script from "./yunsischoolDetail.vue?vue&type=script&lang=js"
export * from "./yunsischoolDetail.vue?vue&type=script&lang=js"
import style0 from "./yunsischoolDetail.vue?vue&type=style&index=0&id=13ece416&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ece416",
  null
  
)

export default component.exports